import { Link } from "react-router-dom";
import { PERSONALITIES } from "../data/site";
import Reveal from "../components/Reveal";
import { PrimaryDoodle } from "../components/PersonalityDoodles";

const BG = {
  "sunshine-chasers": "#F4C734",
  "non-stop-runners": "#EE8C72",
  "tiny-trendsetters": "#C6B9D6",
  "dreamy-wanderers": "#A9CDE5",
  "fearless-tryers": "#F0A8C3",
  "high-energy-kids": "#DD2E20",
  "friendly-explorers": "#8BC547",
};
const INK = {
  "high-energy-kids": "#FAFAF7",
};
const HERO_IMG = {
  "sunshine-chasers": "/products/sol-kid.jpg",
  "non-stop-runners": "/products/rio-kid.jpg",
  "tiny-trendsetters": "/products/chica-kid.jpg",
  "dreamy-wanderers": "/products/luna-kid.jpg",
  "fearless-tryers": "/products/tico-kid.jpg",
  "high-energy-kids": "/products/viva-kid.jpg",
  "friendly-explorers": "/products/lolo-kid.jpg",
};

export default function Personalities() {
  return (
    <div className="pt-32 pb-24 px-5 md:px-10" data-testid="personalities-index">
      <div className="mx-auto max-w-[1440px] mb-12 md:mb-16">
        <Reveal>
          <p className="eyebrow mb-4">By personality</p>
        </Reveal>
        <Reveal delay={60}>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-[112px] leading-[0.95] tracking-[-0.03em] max-w-[16ch]">
            Pick the one that <span className="italic">feels like them.</span>
          </h1>
        </Reveal>
      </div>

      <div className="mx-auto max-w-[1440px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {PERSONALITIES.map((p, i) => (
          <Reveal key={p.slug} delay={i * 60}>
            <Link
              to={`/personality/${p.slug}`}
              className="group block rounded-[28px] p-7 md:p-9 relative overflow-hidden lift min-h-[320px] tilt"
              style={{ background: BG[p.slug], color: INK[p.slug] || "#2C2C2A" }}
              data-testid={`personalities-card-${p.slug}`}
              data-hover="true"
            >
              <div className="relative z-10 h-full flex flex-col justify-between">
                <div>
                  <PrimaryDoodle personality={p.slug} className="!w-12 !h-12 mb-2" />
                  <h2 className="mt-3 font-serif text-3xl md:text-4xl leading-tight tracking-tight">{p.title}</h2>
                  <p className="mt-3 opacity-75 max-w-[20ch]">{p.line}</p>
                </div>
                <span className="mt-6 inline-flex items-center gap-1 text-[13px] font-medium">Shop frames →</span>
              </div>
              <div className="absolute right-[-12%] bottom-[-8%] w-[55%] aspect-[4/5] opacity-95 hidden sm:block">
                <img src={HERO_IMG[p.slug]} alt="" className="w-full h-full object-cover rounded-[24px] rotate-[5deg] group-hover:rotate-[2deg] transition-transform duration-700 shadow-[0_20px_40px_rgba(0,0,0,0.18)]" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
